import { render } from "./leads-details-tabs.vue?vue&type=template&id=2517503a"
import script from "./leads-details-tabs.vue?vue&type=script&lang=js"
export * from "./leads-details-tabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__